import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Report } from '../models/report.model';
import { ReportFolder } from '../models/report-folder.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportParametersComponent } from '../parameters/report-parameters.component';

@AutoUnsubscribe()
@Component({
    selector: 'reportAutoRunMessage',
    templateUrl: './report-autorun-message.component.html'

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class ReportAutoRunMessageComponent implements OnInit, OnDestroy {

    thisDialogRef: MatDialogRef<ReportAutoRunMessageComponent>;

    // loginSettings: LoginSettings;
    allowAutoRunReport: boolean;
    reportFolders: ReportFolder[] = [];
    // //ReportParameters: ReportParameter[]; //??

    Report: Report;
    // reportSettingsDialogRef: MatDialogRef<ReportSettingsComponent>;

    reportsMode: number; // enum: MyReports = 1, AllReports = 2
    inDebugMode: boolean;
    selectedFolderIds: number[] = [];
    reportParametersDialogRef: MatDialogRef<ReportParametersComponent>;

    constructor(
        reportAutoRunMessageDialogRef: MatDialogRef<ReportAutoRunMessageComponent>,
        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent,
        // private loginService: LoginService,
        private dialog: MatDialog,
        private reportParametersDialog: MatDialog,
        // private allReportsComponent: AllReportsComponent

    ) {

        this.thisDialogRef = reportAutoRunMessageDialogRef;
        // this.allowAutoRunReport = this.loginService.LoginSettings.AllowAutoRunReport;
        // this.loginSettings = loginService.LoginSettings;
        this.allowAutoRunReport = this.reportService.allowAutoRunReport;
        this.inDebugMode = reportService.inDebugMode;
        this.Report = this.reportService.SelectedReport;

    }

    ngOnInit() {

        // only needs called if in all reports
        this.selectedFolderIds = this.reportService.selectedFolderIds;


    }

    ngOnDestroy() {

        this.reportService.isForSchedule = false;
    }

    closeClick() {

        this.thisDialogRef.close();

    }

} // end class
